const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternalServerError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M38.888,267.6c0,0,3.638,74.585,66.628,122.456c62.99,47.871,149.193,48.817,219.008,51.424 c69.816,2.607,122.725-38.598,129.808-98.67c7.082-60.072-46.496-76.014-76.535-143.237 c-30.039-67.223-27.837-89.686-89.705-129.712c-61.868-40.026-157.14-11.398-206.127,61.883 C32.978,205.026,38.888,267.6,38.888,267.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M38.888,267.6c0,0,3.638,74.585,66.628,122.456 c62.99,47.871,149.193,48.817,219.008,51.424c69.816,2.607,122.725-38.598,129.808-98.67 c7.082-60.072-46.496-76.014-76.535-143.237c-30.039-67.223-27.837-89.686-89.705-129.712 c-61.868-40.026-157.14-11.398-206.127,61.883C32.978,205.026,38.888,267.6,38.888,267.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBFBF"
    },
    d: "M420.729,372.863c0,0-3.402-14.458-0.851-27.215c2.551-12.757,8.505-4.252,15.309-12.757 s3.402-24.664,11.056-31.467c7.654-6.804,18.71-5.953,21.262-18.71c2.551-12.757,4.252-22.963,9.355-21.262 c5.103,1.701-4.252,17.009-4.252,26.365s5.103,15.309,1.701,24.664c-3.402,9.355-17.86,5.953-17.86,17.009 c0,11.056,5.953,22.112,0.85,29.767c-5.103,7.654-18.711,9.355-20.411,13.608c-1.701,4.252-5.953,11.907-10.206,11.907 C422.43,384.77,420.729,372.863,420.729,372.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBFBF"
    },
    d: "M417.962,373.014c0.85-2.552-0.85-24.664-8.505-28.916c-7.654-4.252-16.159-2.551-20.411-10.206 c-4.252-7.654-4.252-11.056-8.505-11.907c-4.252-0.85-24.664-4.252-22.112,0c2.552,4.252,17.86-2.551,17.86,5.953 c0,8.505-1.701,22.112,3.402,25.514c5.103,3.402,18.71,2.551,17.86,10.206c-0.85,7.654-3.402,10.206,0.85,12.757 c4.252,2.551,16.159,13.608,17.86,5.103C417.962,373.014,417.962,373.014,417.962,373.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeMiterlimit: 10
    },
    d: "M427.427,391.766 c0,0-3.962-12.381,6.934-35.162c10.895-22.781,18.819-40.115,23.772-49.029"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeMiterlimit: 10
    },
    d: "M418.512,393.747 c0,0-1.486-5.943-6.438-22.286c-4.952-16.343-10.895-20.8-19.315-26.248c-8.419-5.448-8.914-14.362-10.4-16.838"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBFBF"
    },
    d: "M439.313,384.832c0,0,0.991-8.914,8.914-11.391c7.924-2.476,15.353-1.486,16.838-6.933 c1.486-5.448,1.486-10.895,4.952-13.867c3.467-2.971,7.924-4.457,8.419-2.971c0.495,1.486-4.952,2.476-4.952,7.429 s7.429,17.333-3.467,22.286c-10.895,4.953-19.81,0.495-23.772,3.962c-3.962,3.467-6.438,5.943-6.438,5.943L439.313,384.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeMiterlimit: 10
    },
    d: "M438.322,393.747 c0,0,3.467-12.876,11.886-15.848c8.419-2.971,17.829,3.467,21.791-2.476c3.962-5.943,0.991-11.886,0.495-15.848"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M443.893,391.766h-30.705c-1.367,0-2.476,1.109-2.476,2.476l0,0c0,1.368,1.109,2.476,2.476,2.476 h0.248l2.391,6.27c0.38,0.996,1.335,1.654,2.4,1.654h20.629c1.066,0,2.021-0.658,2.4-1.654l2.39-6.27h0.248 c1.368,0,2.476-1.109,2.476-2.476l0,0C446.37,392.875,445.261,391.766,443.893,391.766z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M454.211,278.776H307.333c-2.614,0-4.733-2.119-4.733-4.733V255.47 c0-2.614,2.119-4.734,4.734-4.734h146.878c2.614,0,4.734,2.119,4.734,4.734v18.573 C458.945,276.657,456.826,278.776,454.211,278.776z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M314.675,268.614c-0.145-0.125-0.217-0.298-0.217-0.519v-9.1c0-0.221,0.075-0.395,0.225-0.523 c0.15-0.128,0.325-0.191,0.526-0.191c0.201,0,0.374,0.063,0.519,0.188c0.145,0.125,0.217,0.301,0.217,0.527v9.1 c0,0.226-0.074,0.4-0.221,0.523c-0.147,0.123-0.324,0.184-0.53,0.184C314.992,268.802,314.819,268.739,314.675,268.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M318.735,268.643c-0.128-0.111-0.191-0.266-0.191-0.468v-6.052c0-0.196,0.066-0.35,0.199-0.46 c0.133-0.111,0.29-0.166,0.471-0.166c0.181,0,0.337,0.053,0.467,0.158c0.13,0.105,0.195,0.254,0.195,0.445v0.641 c0.186-0.447,0.492-0.79,0.917-1.031c0.425-0.24,0.919-0.361,1.484-0.361c0.81,0,1.455,0.236,1.936,0.707 c0.481,0.471,0.721,1.185,0.721,2.143v3.976c0,0.201-0.065,0.357-0.195,0.468c-0.13,0.11-0.286,0.166-0.467,0.166 c-0.182,0-0.338-0.055-0.468-0.166c-0.13-0.111-0.195-0.266-0.195-0.468v-3.99c0-0.628-0.146-1.107-0.438-1.436 c-0.292-0.329-0.703-0.493-1.233-0.493c-0.564,0-1.041,0.201-1.428,0.604c-0.388,0.402-0.599,0.95-0.633,1.642v3.674 c0,0.196-0.068,0.351-0.203,0.464c-0.135,0.113-0.293,0.169-0.475,0.169C319.017,268.809,318.863,268.754,318.735,268.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M328.122,268.363c-0.334-0.366-0.501-0.929-0.501-1.69v-4.241h-0.898 c-0.162,0-0.286-0.039-0.372-0.118c-0.086-0.079-0.129-0.184-0.129-0.317c0-0.128,0.042-0.232,0.125-0.313 c0.083-0.081,0.206-0.121,0.368-0.121h0.906l0.177-2.091c0.01-0.157,0.08-0.292,0.21-0.405c0.13-0.113,0.274-0.169,0.431-0.169 c0.147,0,0.27,0.046,0.368,0.136c0.098,0.091,0.147,0.222,0.147,0.394v2.135h1.355c0.162,0,0.283,0.042,0.364,0.125 c0.081,0.083,0.122,0.191,0.122,0.324c0,0.28-0.162,0.42-0.486,0.42h-1.355v4.013c0,0.505,0.071,0.87,0.214,1.093 c0.142,0.223,0.368,0.335,0.677,0.335h0.081l0.501-0.022h0.044c0.162,0,0.29,0.052,0.383,0.155 c0.093,0.103,0.14,0.223,0.14,0.361c0,0.123-0.027,0.222-0.081,0.298c-0.054,0.076-0.136,0.131-0.247,0.166 c-0.111,0.034-0.221,0.056-0.331,0.066c-0.11,0.01-0.254,0.015-0.431,0.015h-0.434 C328.905,268.912,328.456,268.729,328.122,268.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M333.865,268.485c-0.545-0.299-0.978-0.74-1.299-1.322c-0.322-0.582-0.482-1.26-0.482-2.036 c0-0.682,0.135-1.306,0.405-1.87c0.27-0.564,0.677-1.023,1.222-1.377c0.545-0.353,1.18-0.53,1.907-0.53 c0.574,0,1.077,0.096,1.509,0.287c0.432,0.191,0.776,0.455,1.031,0.792c0.255,0.336,0.447,0.712,0.574,1.126 c0.128,0.415,0.199,0.87,0.214,1.366c0,0.142-0.039,0.26-0.118,0.353c-0.079,0.093-0.196,0.14-0.353,0.14h-5.051 c0.01,0.844,0.236,1.484,0.677,1.918c0.442,0.434,1.009,0.657,1.701,0.666c0.437,0,0.829-0.079,1.178-0.236 c0.349-0.157,0.699-0.371,1.053-0.641c0.088-0.069,0.182-0.103,0.28-0.103c0.118,0,0.217,0.045,0.298,0.136 c0.081,0.091,0.122,0.198,0.122,0.32c0,0.157-0.069,0.297-0.206,0.42c-0.775,0.697-1.713,1.046-2.812,1.046 C335.026,268.937,334.41,268.784,333.865,268.485z M337.782,264.598c-0.044-0.687-0.238-1.249-0.582-1.686 c-0.344-0.437-0.847-0.655-1.509-0.655c-0.344,0-0.655,0.066-0.935,0.199c-0.28,0.133-0.509,0.31-0.688,0.534 c-0.179,0.223-0.322,0.471-0.427,0.744c-0.106,0.272-0.171,0.561-0.195,0.865H337.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M340.985,268.647c-0.128-0.108-0.191-0.26-0.191-0.456v-6.074c0-0.196,0.066-0.347,0.199-0.453 c0.133-0.106,0.29-0.158,0.471-0.158c0.182,0,0.338,0.053,0.467,0.158c0.13,0.105,0.195,0.251,0.195,0.438l-0.008,0.884 c0.123-0.456,0.37-0.838,0.74-1.145c0.371-0.307,0.816-0.46,1.336-0.46c0.157,0,0.281,0.059,0.372,0.177 c0.091,0.118,0.136,0.255,0.136,0.412c0,0.147-0.042,0.274-0.125,0.379c-0.083,0.105-0.204,0.158-0.361,0.158 c-0.663,0-1.177,0.172-1.542,0.515c-0.366,0.344-0.548,0.802-0.548,1.377v3.792c0,0.196-0.068,0.348-0.203,0.456 c-0.135,0.108-0.293,0.162-0.475,0.162C341.267,268.809,341.112,268.755,340.985,268.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M346.33,268.643c-0.128-0.111-0.191-0.266-0.191-0.468v-6.052c0-0.196,0.066-0.35,0.199-0.46 c0.133-0.111,0.29-0.166,0.471-0.166c0.182,0,0.337,0.053,0.467,0.158c0.13,0.105,0.195,0.254,0.195,0.445v0.641 c0.186-0.447,0.492-0.79,0.917-1.031c0.425-0.24,0.919-0.361,1.484-0.361c0.81,0,1.455,0.236,1.936,0.707 c0.481,0.471,0.721,1.185,0.721,2.143v3.976c0,0.201-0.065,0.357-0.195,0.468c-0.13,0.11-0.286,0.166-0.468,0.166 c-0.181,0-0.337-0.055-0.467-0.166c-0.13-0.111-0.195-0.266-0.195-0.468v-3.99c0-0.628-0.146-1.107-0.438-1.436 s-0.703-0.493-1.233-0.493c-0.564,0-1.04,0.201-1.428,0.604c-0.388,0.402-0.599,0.95-0.633,1.642v3.674 c0,0.196-0.068,0.351-0.202,0.464c-0.135,0.113-0.293,0.169-0.475,0.169C346.612,268.809,346.458,268.754,346.33,268.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354.79,268.389c-0.481-0.368-0.721-0.891-0.721-1.568c0-0.28,0.029-0.525,0.088-0.736 c0.059-0.211,0.142-0.396,0.25-0.556c0.108-0.159,0.26-0.294,0.457-0.405c0.196-0.111,0.412-0.201,0.648-0.273 c0.236-0.071,0.535-0.125,0.898-0.162c0.363-0.037,0.737-0.063,1.123-0.077c0.385-0.015,0.85-0.022,1.395-0.022v-0.803 c0-0.525-0.14-0.913-0.42-1.163c-0.28-0.25-0.67-0.376-1.171-0.376c-0.299,0-0.599,0.032-0.898,0.096 c-0.299,0.064-0.535,0.128-0.707,0.191c-0.172,0.064-0.383,0.152-0.633,0.265c-0.049,0.025-0.108,0.037-0.177,0.037 c-0.128,0-0.238-0.053-0.331-0.158c-0.093-0.105-0.14-0.222-0.14-0.35c0-0.147,0.069-0.26,0.206-0.339 c0.761-0.427,1.666-0.641,2.717-0.641c0.898,0,1.602,0.209,2.109,0.626c0.508,0.417,0.762,1.06,0.762,1.929v4.292 c0,0.191-0.068,0.342-0.203,0.453c-0.135,0.11-0.291,0.166-0.467,0.166c-0.177,0-0.328-0.053-0.453-0.158 c-0.125-0.106-0.188-0.254-0.188-0.446v-0.707c-0.456,0.957-1.212,1.436-2.268,1.436 C355.896,268.942,355.271,268.758,354.79,268.389z M358.29,267.359c0.424-0.466,0.637-1.06,0.637-1.782v-0.221 c-0.609,0-1.104,0.011-1.487,0.033c-0.383,0.022-0.722,0.061-1.016,0.118c-0.295,0.056-0.515,0.14-0.663,0.25 c-0.147,0.111-0.256,0.244-0.328,0.401c-0.071,0.157-0.107,0.358-0.107,0.604c0,0.447,0.133,0.774,0.398,0.983 c0.265,0.209,0.626,0.313,1.082,0.313C357.371,268.058,357.866,267.825,358.29,267.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M362.69,268.636c-0.128-0.115-0.191-0.281-0.191-0.497v-9.181c0-0.206,0.068-0.368,0.202-0.486 c0.135-0.118,0.293-0.177,0.475-0.177c0.177,0,0.33,0.059,0.46,0.177c0.13,0.118,0.195,0.28,0.195,0.486v9.181 c0,0.206-0.067,0.369-0.202,0.49c-0.135,0.12-0.293,0.18-0.475,0.18C362.972,268.809,362.817,268.751,362.69,268.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M370.302,267.705c-0.059-0.054-0.088-0.128-0.088-0.221c0-0.157,0.075-0.319,0.224-0.486 c0.15-0.167,0.301-0.25,0.453-0.25c0.069,0,0.13,0.02,0.184,0.059c0.835,0.648,1.801,0.972,2.901,0.972 c0.717,0,1.302-0.142,1.756-0.427c0.454-0.285,0.681-0.697,0.681-1.237c0-0.26-0.033-0.482-0.099-0.666 c-0.066-0.184-0.177-0.345-0.331-0.482c-0.155-0.137-0.33-0.253-0.526-0.346c-0.196-0.093-0.452-0.194-0.766-0.302l-2.113-0.707 c-0.78-0.265-1.362-0.599-1.745-1.001c-0.383-0.402-0.574-0.957-0.574-1.664c0-0.569,0.166-1.07,0.497-1.502 c0.331-0.432,0.778-0.758,1.34-0.979c0.562-0.221,1.196-0.331,1.903-0.331c0.692,0,1.353,0.112,1.984,0.335 c0.631,0.223,1.113,0.485,1.447,0.784c0.113,0.098,0.169,0.221,0.169,0.368c0,0.152-0.056,0.29-0.169,0.412 c-0.113,0.123-0.248,0.184-0.405,0.184c-0.113,0-0.221-0.034-0.324-0.103c-0.299-0.196-0.676-0.377-1.13-0.541 c-0.454-0.165-0.939-0.247-1.454-0.247c-0.736,0-1.325,0.135-1.767,0.405c-0.442,0.27-0.663,0.66-0.663,1.171 c0,0.383,0.114,0.688,0.342,0.917c0.228,0.228,0.593,0.426,1.093,0.592l2.12,0.685c0.427,0.137,0.789,0.282,1.086,0.434 c0.297,0.152,0.567,0.337,0.81,0.556c0.243,0.219,0.425,0.48,0.545,0.784c0.12,0.304,0.181,0.655,0.181,1.053 c0,0.962-0.355,1.711-1.064,2.245c-0.709,0.535-1.672,0.803-2.89,0.803C372.413,268.971,371.211,268.549,370.302,267.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M381.14,268.485c-0.545-0.299-0.978-0.74-1.3-1.322c-0.321-0.582-0.482-1.26-0.482-2.036 c0-0.682,0.135-1.306,0.405-1.87c0.27-0.564,0.677-1.023,1.222-1.377c0.545-0.353,1.18-0.53,1.907-0.53 c0.574,0,1.077,0.096,1.509,0.287c0.432,0.191,0.775,0.455,1.031,0.792c0.255,0.336,0.447,0.712,0.574,1.126 c0.128,0.415,0.199,0.87,0.214,1.366c0,0.142-0.039,0.26-0.118,0.353c-0.078,0.093-0.196,0.14-0.353,0.14h-5.051 c0.01,0.844,0.236,1.484,0.677,1.918c0.442,0.434,1.009,0.657,1.701,0.666c0.437,0,0.83-0.079,1.178-0.236 c0.349-0.157,0.7-0.371,1.053-0.641c0.088-0.069,0.181-0.103,0.28-0.103c0.118,0,0.217,0.045,0.298,0.136 c0.081,0.091,0.122,0.198,0.122,0.32c0,0.157-0.069,0.297-0.206,0.42c-0.776,0.697-1.713,1.046-2.813,1.046 C382.301,268.937,381.685,268.784,381.14,268.485z M385.057,264.598c-0.044-0.687-0.238-1.249-0.582-1.686 c-0.344-0.437-0.847-0.655-1.509-0.655c-0.344,0-0.655,0.066-0.935,0.199c-0.28,0.133-0.509,0.31-0.689,0.534 c-0.179,0.223-0.321,0.471-0.427,0.744c-0.105,0.272-0.171,0.561-0.195,0.865H385.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M388.26,268.647c-0.128-0.108-0.191-0.26-0.191-0.456v-6.074c0-0.196,0.066-0.347,0.199-0.453 c0.133-0.106,0.29-0.158,0.471-0.158c0.182,0,0.337,0.053,0.468,0.158c0.13,0.105,0.195,0.251,0.195,0.438l-0.007,0.884 c0.123-0.456,0.369-0.838,0.74-1.145c0.371-0.307,0.816-0.46,1.336-0.46c0.157,0,0.281,0.059,0.372,0.177 c0.091,0.118,0.136,0.255,0.136,0.412c0,0.147-0.042,0.274-0.125,0.379s-0.204,0.158-0.361,0.158 c-0.663,0-1.177,0.172-1.542,0.515c-0.366,0.344-0.549,0.802-0.549,1.377v3.792c0,0.196-0.067,0.348-0.202,0.456 c-0.135,0.108-0.293,0.162-0.475,0.162C388.542,268.809,388.387,268.755,388.26,268.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M395.486,268.592c-0.159-0.15-0.315-0.406-0.468-0.769l-2.297-5.5 c-0.03-0.064-0.044-0.132-0.044-0.206c0-0.167,0.07-0.313,0.21-0.438c0.14-0.125,0.296-0.188,0.467-0.188 c0.255,0,0.437,0.14,0.545,0.42l2.253,5.544l2.246-5.544c0.108-0.28,0.29-0.42,0.545-0.42c0.172,0,0.327,0.063,0.467,0.188 c0.14,0.125,0.21,0.271,0.21,0.438c0,0.074-0.015,0.142-0.044,0.206l-2.297,5.5c-0.152,0.363-0.308,0.62-0.467,0.769 c-0.16,0.15-0.379,0.225-0.659,0.225C395.868,268.816,395.646,268.741,395.486,268.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M402.388,268.485c-0.545-0.299-0.978-0.74-1.299-1.322c-0.322-0.582-0.482-1.26-0.482-2.036 c0-0.682,0.135-1.306,0.405-1.87c0.27-0.564,0.677-1.023,1.222-1.377c0.545-0.353,1.181-0.53,1.907-0.53 c0.574,0,1.077,0.096,1.509,0.287c0.432,0.191,0.776,0.455,1.031,0.792c0.255,0.336,0.447,0.712,0.574,1.126 c0.128,0.415,0.199,0.87,0.214,1.366c0,0.142-0.039,0.26-0.118,0.353c-0.079,0.093-0.196,0.14-0.354,0.14h-5.051 c0.01,0.844,0.236,1.484,0.677,1.918c0.442,0.434,1.009,0.657,1.701,0.666c0.437,0,0.829-0.079,1.178-0.236 c0.348-0.157,0.699-0.371,1.053-0.641c0.088-0.069,0.182-0.103,0.28-0.103c0.118,0,0.217,0.045,0.298,0.136 c0.081,0.091,0.122,0.198,0.122,0.32c0,0.157-0.069,0.297-0.206,0.42c-0.776,0.697-1.713,1.046-2.813,1.046 C403.549,268.937,402.933,268.784,402.388,268.485z M406.305,264.598c-0.044-0.687-0.238-1.249-0.582-1.686 c-0.344-0.437-0.847-0.655-1.509-0.655c-0.344,0-0.655,0.066-0.935,0.199c-0.28,0.133-0.509,0.31-0.688,0.534 c-0.179,0.223-0.322,0.471-0.427,0.744c-0.106,0.272-0.171,0.561-0.195,0.865H406.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M409.508,268.647c-0.128-0.108-0.191-0.26-0.191-0.456v-6.074c0-0.196,0.066-0.347,0.199-0.453 c0.133-0.106,0.29-0.158,0.471-0.158c0.182,0,0.337,0.053,0.467,0.158c0.13,0.105,0.195,0.251,0.195,0.438l-0.007,0.884 c0.123-0.456,0.369-0.838,0.74-1.145c0.371-0.307,0.816-0.46,1.336-0.46c0.157,0,0.281,0.059,0.372,0.177 c0.091,0.118,0.136,0.255,0.136,0.412c0,0.147-0.042,0.274-0.125,0.379c-0.083,0.105-0.204,0.158-0.361,0.158 c-0.663,0-1.177,0.172-1.542,0.515c-0.366,0.344-0.548,0.802-0.548,1.377v3.792c0,0.196-0.068,0.348-0.202,0.456 c-0.135,0.108-0.293,0.162-0.475,0.162C409.79,268.809,409.636,268.755,409.508,268.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M419.348,268.592c-0.15-0.145-0.225-0.313-0.225-0.504v-9.078c0-0.191,0.068-0.359,0.203-0.504 c0.135-0.145,0.301-0.217,0.497-0.217h5.456c0.186,0,0.331,0.058,0.434,0.173c0.103,0.115,0.154,0.254,0.154,0.416 c0,0.162-0.051,0.302-0.154,0.42c-0.103,0.118-0.248,0.177-0.434,0.177h-4.668v3.35h4.418c0.191,0,0.339,0.056,0.442,0.169 c0.103,0.113,0.155,0.248,0.155,0.405c0,0.157-0.053,0.293-0.158,0.409c-0.105,0.115-0.252,0.173-0.438,0.173h-4.418v3.645 h4.859c0.186,0,0.331,0.059,0.434,0.177c0.103,0.118,0.155,0.258,0.155,0.42c0,0.162-0.052,0.301-0.155,0.416 c-0.103,0.115-0.248,0.173-0.434,0.173h-5.61C419.668,268.809,419.498,268.737,419.348,268.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M428.283,268.647c-0.128-0.108-0.191-0.26-0.191-0.456v-6.074c0-0.196,0.066-0.347,0.199-0.453 c0.133-0.106,0.29-0.158,0.471-0.158c0.182,0,0.338,0.053,0.467,0.158c0.13,0.105,0.195,0.251,0.195,0.438l-0.007,0.884 c0.123-0.456,0.369-0.838,0.74-1.145c0.371-0.307,0.816-0.46,1.336-0.46c0.157,0,0.281,0.059,0.372,0.177 c0.091,0.118,0.136,0.255,0.136,0.412c0,0.147-0.042,0.274-0.125,0.379c-0.083,0.105-0.204,0.158-0.361,0.158 c-0.663,0-1.177,0.172-1.543,0.515c-0.366,0.344-0.548,0.802-0.548,1.377v3.792c0,0.196-0.068,0.348-0.203,0.456 c-0.135,0.108-0.293,0.162-0.475,0.162C428.565,268.809,428.41,268.755,428.283,268.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M433.642,268.647c-0.128-0.108-0.191-0.26-0.191-0.456v-6.074c0-0.196,0.066-0.347,0.199-0.453 c0.132-0.106,0.289-0.158,0.471-0.158c0.182,0,0.337,0.053,0.467,0.158c0.13,0.105,0.195,0.251,0.195,0.438l-0.007,0.884 c0.123-0.456,0.369-0.838,0.74-1.145c0.371-0.307,0.816-0.46,1.336-0.46c0.157,0,0.281,0.059,0.372,0.177 c0.091,0.118,0.136,0.255,0.136,0.412c0,0.147-0.042,0.274-0.125,0.379c-0.083,0.105-0.204,0.158-0.361,0.158 c-0.663,0-1.177,0.172-1.543,0.515s-0.548,0.802-0.548,1.377v3.792c0,0.196-0.068,0.348-0.203,0.456 c-0.135,0.108-0.293,0.162-0.475,0.162C433.925,268.809,433.77,268.755,433.642,268.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M439.293,267.874c-0.665-0.712-0.998-1.62-0.998-2.724c0-1.109,0.333-2.02,0.998-2.732 c0.665-0.712,1.562-1.068,2.691-1.068c1.129,0,2.026,0.355,2.691,1.064c0.665,0.709,0.998,1.621,0.998,2.735 c0,1.104-0.331,2.012-0.994,2.724c-0.663,0.712-1.561,1.068-2.695,1.068C440.855,268.942,439.958,268.586,439.293,267.874z  M443.725,267.259c0.415-0.513,0.622-1.216,0.622-2.109c0-0.888-0.21-1.593-0.629-2.113c-0.42-0.52-0.998-0.78-1.734-0.78 c-0.741,0-1.32,0.259-1.738,0.777c-0.417,0.518-0.626,1.223-0.626,2.117c0,0.884,0.207,1.584,0.622,2.102 c0.415,0.518,0.99,0.777,1.727,0.777C442.725,268.029,443.311,267.772,443.725,267.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M447.528,268.647c-0.128-0.108-0.191-0.26-0.191-0.456v-6.074c0-0.196,0.066-0.347,0.199-0.453 c0.132-0.106,0.29-0.158,0.471-0.158c0.182,0,0.337,0.053,0.467,0.158c0.13,0.105,0.195,0.251,0.195,0.438l-0.007,0.884 c0.123-0.456,0.369-0.838,0.74-1.145c0.371-0.307,0.816-0.46,1.336-0.46c0.157,0,0.281,0.059,0.372,0.177 c0.091,0.118,0.136,0.255,0.136,0.412c0,0.147-0.042,0.274-0.125,0.379c-0.083,0.105-0.204,0.158-0.361,0.158 c-0.663,0-1.177,0.172-1.543,0.515c-0.366,0.344-0.548,0.802-0.548,1.377v3.792c0,0.196-0.068,0.348-0.202,0.456 c-0.135,0.108-0.293,0.162-0.475,0.162C447.81,268.809,447.656,268.755,447.528,268.647z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M316.796,235.121c-0.809-0.734-1.212-1.652-1.212-2.753c0-1.15,0.422-2.209,1.266-3.176 c0.845-0.967,1.793-1.45,2.846-1.45c0.342,0,0.686,0.061,1.028,0.184c0.342,0.123,0.674,0.307,0.992,0.551 c3.304,2.57,6.829,3.854,10.574,3.854c2.864,0,5.067-0.752,6.609-2.258c1.543-1.505,2.313-3.727,2.313-6.663 c0-2.815-0.826-5.011-2.479-6.591c-1.652-1.579-3.727-2.368-6.222-2.368c-2.864,0-5.63,1.004-8.298,3.011 c-0.491,0.416-1.176,0.623-2.057,0.623c-1.346,0-2.595-0.453-3.745-1.358c-1.151-0.906-1.725-2.13-1.725-3.671v-20.854 c0-2.08,0.501-3.5,1.506-4.259c1.002-0.759,2.68-1.139,5.03-1.139h22.102c1.199,0,2.16,0.368,2.883,1.102 c0.721,0.734,1.082,1.738,1.082,3.011c0,1.273-0.379,2.271-1.138,2.992c-0.76,0.722-1.823,1.083-3.194,1.083h-18.908 l-0.184,13.989l1.102-0.661c0.734-0.441,1.945-0.882,3.634-1.322c1.689-0.441,3.475-0.661,5.36-0.661 c4.798,0,8.707,1.506,11.731,4.516c3.022,3.011,4.534,7.136,4.534,12.373c0,3.55-0.869,6.671-2.606,9.363 c-1.739,2.692-4.089,4.736-7.05,6.132c-2.962,1.395-6.291,2.092-9.986,2.092C326.562,240.812,321.299,238.916,316.796,235.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M371.079,239.564c-2.362-0.979-4.308-2.307-5.837-3.984c-1.53-1.676-2.797-3.701-3.8-6.075 c-1.004-2.374-1.714-4.878-2.129-7.509c-0.417-2.631-0.625-5.477-0.625-8.537c0-3.011,0.207-5.813,0.625-8.407 c0.415-2.595,1.119-5.079,2.11-7.454c0.992-2.374,2.246-4.394,3.764-6.058c1.517-1.664,3.463-2.992,5.837-3.984 c2.374-0.991,5.067-1.487,8.078-1.487c2.961,0,5.612,0.484,7.949,1.45c2.337,0.968,4.27,2.277,5.801,3.929 c1.53,1.652,2.803,3.66,3.819,6.021c1.015,2.363,1.738,4.853,2.166,7.472c0.428,2.619,0.643,5.459,0.643,8.518 c0,3.036-0.209,5.869-0.625,8.5c-0.416,2.631-1.126,5.134-2.129,7.509c-1.004,2.374-2.271,4.399-3.8,6.075 c-1.53,1.677-3.47,3.011-5.819,4.003c-2.35,0.992-5.019,1.487-8.004,1.487C376.115,241.033,373.441,240.542,371.079,239.564z  M383.654,231.027c1.223-0.967,2.135-2.379,2.735-4.241c0.6-1.859,1.016-3.83,1.248-5.911c0.233-2.08,0.35-4.552,0.35-7.416 c0-2.252-0.061-4.228-0.184-5.929c-0.123-1.701-0.373-3.402-0.752-5.103c-0.38-1.701-0.888-3.096-1.524-4.186 c-0.637-1.089-1.493-1.97-2.571-2.644c-1.077-0.672-2.362-1.009-3.854-1.009c-1.248,0-2.35,0.22-3.305,0.661 c-0.955,0.44-1.75,1.096-2.387,1.965c-0.637,0.869-1.169,1.848-1.596,2.937c-0.43,1.089-0.759,2.38-0.991,3.873 c-0.233,1.493-0.393,2.974-0.477,4.443c-0.086,1.469-0.129,3.133-0.129,4.993c0,1.86,0.043,3.531,0.129,5.011 c0.085,1.481,0.244,2.974,0.477,4.48c0.232,1.505,0.562,2.809,0.991,3.91c0.427,1.102,0.96,2.087,1.596,2.956 c0.637,0.869,1.432,1.53,2.387,1.983c0.955,0.453,2.057,0.678,3.305,0.678C380.913,232.478,382.429,231.994,383.654,231.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M417.561,239.564c-2.362-0.979-4.308-2.307-5.837-3.984c-1.53-1.676-2.797-3.701-3.8-6.075 c-1.004-2.374-1.714-4.878-2.129-7.509c-0.417-2.631-0.624-5.477-0.624-8.537c0-3.011,0.207-5.813,0.624-8.407 c0.415-2.595,1.119-5.079,2.111-7.454c0.992-2.374,2.246-4.394,3.763-6.058c1.517-1.664,3.463-2.992,5.837-3.984 c2.374-0.991,5.067-1.487,8.078-1.487c2.961,0,5.611,0.484,7.949,1.45c2.336,0.968,4.27,2.277,5.8,3.929 c1.53,1.652,2.803,3.66,3.819,6.021c1.015,2.363,1.737,4.853,2.166,7.472c0.428,2.619,0.643,5.459,0.643,8.518 c0,3.036-0.209,5.869-0.625,8.5c-0.416,2.631-1.126,5.134-2.129,7.509c-1.004,2.374-2.271,4.399-3.801,6.075 c-1.53,1.677-3.47,3.011-5.819,4.003c-2.35,0.992-5.019,1.487-8.004,1.487C422.597,241.033,419.923,240.542,417.561,239.564z  M430.136,231.027c1.223-0.967,2.135-2.379,2.735-4.241c0.6-1.859,1.016-3.83,1.248-5.911c0.233-2.08,0.35-4.552,0.35-7.416 c0-2.252-0.061-4.228-0.184-5.929c-0.123-1.701-0.373-3.402-0.752-5.103c-0.38-1.701-0.888-3.096-1.524-4.186 c-0.637-1.089-1.493-1.97-2.571-2.644c-1.077-0.672-2.362-1.009-3.854-1.009c-1.248,0-2.35,0.22-3.305,0.661 c-0.955,0.44-1.75,1.096-2.387,1.965c-0.637,0.869-1.169,1.848-1.596,2.937c-0.43,1.089-0.76,2.38-0.992,3.873 c-0.233,1.493-0.393,2.974-0.477,4.443c-0.086,1.469-0.129,3.133-0.129,4.993c0,1.86,0.043,3.531,0.129,5.011 c0.085,1.481,0.244,2.974,0.477,4.48c0.232,1.505,0.562,2.809,0.992,3.91c0.427,1.102,0.96,2.087,1.596,2.956 c0.637,0.869,1.432,1.53,2.387,1.983c0.955,0.453,2.057,0.678,3.305,0.678C427.395,232.478,428.911,231.994,430.136,231.027z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Server"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M100.148,342.69 l69.017-58.207c2.563-2.162,6.001-2.362,8.741-0.509l86.963,58.792l43.655-29.756c2.264-1.543,5.061-1.637,7.4-0.247 l50.315,29.898"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M346.223,330.648 l16.994-6.818c1.972-0.791,4.141-0.62,6,0.474l31.489,18.526"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M132.948,314.833 l-7.578-4.971c-2.609-1.609-5.784-1.393-8.209,0.559L77.058,342.69"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 71.071,
    y1: 342.766,
    x2: 416.138,
    y2: 342.766
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 291.242,
    y1: 329.852,
    x2: 292.734,
    y2: 328.852
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 271.881,
    y1: 342.828,
    x2: 289.271,
    y2: 331.173
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 148.097,
    y1: 309.489,
    x2: 151.101,
    y2: 306.92
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 109.108,
    y1: 342.828,
    x2: 144.126,
    y2: 312.884
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2.5131,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M153.006,338.543c0,0,9.516-1.886,17.683,4.397c8.167,6.283,14.383,22.254,17.592,44.607 c3.209,22.354,5.026,32.042,23.874,35.183c18.848,3.141,64.084,1.885,91.099,1.257c27.016-0.628,25.759-25.759,3.141-28.272 c-22.618-2.513-38.267,3.523-61.856-1.694c-23.589-5.217,21.018-12.128,54.945-7.102c33.927,5.026,49.005,6.283,67.225,4.398"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2.5131,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M153.006,305.096c0,0,18.311,0.148,23.338,18.996c5.026,18.848,6.911,45.236,7.539,65.969 c0.628,20.733,1.257,38.324,25.131,43.351c23.874,5.026,88.586,3.141,106.178-0.628c17.592-3.77,37.068-20.733,22.618-24.503 c-14.45-3.77-34.555,0-27.016,5.026c7.539,5.026,27.644,3.77,51.518,0.628"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2.5131,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M156.761,370.686c0,0,11.186-0.973,15.563,11.672c4.377,12.645-0.973,15.563,1.459,21.886s17.776,0.419,17.705,5.657 c-0.064,4.78-6.126,6.125-41.05,4.07c-45.661-2.688-75.871,4.377-73.439,8.755c2.432,4.377,38.908,0.973,30.154,7.782 s-30.154-0.973-46.69-1.459c-16.536-0.486-19.454,3.405-19.454,3.405"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M158.117,192.045H48.171c-1.966,0-3.56,1.594-3.56,3.56v208.28c0,1.966,1.594,3.56,3.56,3.56h109.946 c1.966,0,3.56-1.594,3.56-3.56v-208.28C161.676,193.639,160.082,192.045,158.117,192.045z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.409,
    y: 224.314,
    style: {
      fill: "#616161"
    },
    width: 111.413,
    height: 82.513
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.409,
    y: 320.23,
    style: {
      fill: "#616161"
    },
    width: 111.413,
    height: 82.513
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.754,
    y: 330.283,
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 63.246,
    height: 64.502
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.754,
    y: 233.529,
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 63.246,
    height: 15.916
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.754,
    y: 264.105,
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 63.246,
    height: 15.916
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 142.884,226.161 141.662,229.506 85.631,229.506 84.409,226.161 72.539,226.161 72.539,240.878 84.409,240.878 85.631,237.533  141.662,237.533 142.884,240.878 156.325,240.878 156.325,226.161  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 142.884,242.216 141.662,245.56 85.631,245.56 84.409,242.216 72.539,242.216 72.539,256.932 84.409,256.932 85.631,253.588  141.662,253.588 142.884,256.932 156.325,256.932 156.325,242.216  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 142.884,258.27 141.662,261.615 85.631,261.615 84.409,258.27 72.539,258.27 72.539,272.987 84.409,272.987 85.631,269.642  141.662,269.642 142.884,272.987 156.325,272.987 156.325,258.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 142.884,274.325 141.662,277.67 85.631,277.67 84.409,274.325 72.539,274.325 72.539,289.042 84.409,289.042 85.631,285.697  141.662,285.697 142.884,289.042 156.325,289.042 156.325,274.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 142.884,290.379 141.662,293.724 85.631,293.724 84.409,290.379 72.539,290.379 72.539,305.096 84.409,305.096 85.631,301.751  141.662,301.751 142.884,305.096 156.325,305.096 156.325,290.379  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 142.884,322.489 141.662,325.833 85.631,325.833 84.409,322.489 72.539,322.489 72.539,337.205 84.409,337.205 85.631,333.861  141.662,333.861 142.884,337.205 156.325,337.205 156.325,322.489  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 142.884,338.543 141.662,341.888 85.631,341.888 84.409,338.543 72.539,338.543 72.539,353.26 84.409,353.26 85.631,349.915  141.662,349.915 142.884,353.26 156.325,353.26 156.325,338.543  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 142.884,354.598 141.662,357.943 85.631,357.943 84.409,354.598 72.539,354.598 72.539,369.315 84.409,369.315 85.631,365.97  141.662,365.97 142.884,369.315 156.325,369.315 156.325,354.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 142.884,370.653 141.662,373.997 85.631,373.997 84.409,370.653 72.539,370.653 72.539,385.369 84.409,385.369 85.631,382.025  141.662,382.025 142.884,385.369 156.325,385.369 156.325,370.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 142.884,386.707 141.662,390.052 85.631,390.052 84.409,386.707 72.539,386.707 72.539,401.424 84.409,401.424 85.631,398.079  141.662,398.079 142.884,401.424 156.325,401.424 156.325,386.707  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.652,
    y: 309.39,
    style: {
      fill: "#FFFFFF"
    },
    width: 106.646,
    height: 10.053
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M58.648,314.309c0-1.552-1.258-2.81-2.811-2.81s-2.811,1.258-2.811,2.81c0,1.552,1.258,2.811,2.811,2.811 S58.648,315.861,58.648,314.309z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 65.201,
    cy: 314.309,
    r: 2.81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M77.374,314.309c0-1.552-1.258-2.81-2.81-2.81s-2.811,1.258-2.811,2.81c0,1.552,1.258,2.811,2.811,2.811 S77.374,315.861,77.374,314.309z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.652,
    y: 213.055,
    style: {
      fill: "#FFFFFF"
    },
    width: 106.646,
    height: 10.053
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M58.648,217.974c0-1.552-1.258-2.811-2.811-2.811s-2.811,1.258-2.811,2.811s1.258,2.811,2.811,2.811 S58.648,219.526,58.648,217.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M68.011,217.974c0-1.552-1.258-2.811-2.811-2.811s-2.811,1.258-2.811,2.811s1.258,2.811,2.811,2.811 S68.011,219.526,68.011,217.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M77.374,217.974c0-1.552-1.258-2.811-2.81-2.811s-2.811,1.258-2.811,2.811s1.258,2.811,2.811,2.811 S77.374,219.526,77.374,217.974z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.652,
    y: 200.129,
    style: {
      fill: "#FFFFFF"
    },
    width: 106.646,
    height: 10.053
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M58.648,205.047c0-1.552-1.258-2.811-2.811-2.811s-2.811,1.258-2.811,2.811c0,1.552,1.258,2.811,2.811,2.811 S58.648,206.6,58.648,205.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M68.011,205.047c0-1.552-1.258-2.811-2.811-2.811s-2.811,1.258-2.811,2.811c0,1.552,1.258,2.811,2.811,2.811 S68.011,206.6,68.011,205.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M77.374,205.047c0-1.552-1.258-2.811-2.81-2.811s-2.811,1.258-2.811,2.811c0,1.552,1.258,2.811,2.811,2.811 S77.374,206.6,77.374,205.047z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.922,
    y: 226.409,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 17.592,
    height: 7.539
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.922,
    y: 242.744,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 17.592,
    height: 7.539
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.922,
    y: 259.079,
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 17.592,
    height: 7.539
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.922,
    y: 275.414,
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 17.592,
    height: 7.539
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.922,
    y: 291.749,
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 17.592,
    height: 7.539
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.922,
    y: 322.325,
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 17.592,
    height: 7.539
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.922,
    y: 338.66,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 17.592,
    height: 7.539
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.922,
    y: 354.995,
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 17.592,
    height: 7.539
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.922,
    y: 371.33,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 17.592,
    height: 7.539
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.922,
    y: 387.665,
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 17.592,
    height: 7.539
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M214.836,146.358c0,0-16.855,4.295-21.535,10.699c-4.68,6.404-23.647,50.003-23.647,50.003s-6.158,6.897,0.493,13.548 c6.651,6.65,19.952,9.114,24.878,3.202c4.926-5.912,12.069-33.746,13.055-36.948c0.985-3.202,8.375-30.297,9.114-31.775 C217.933,153.608,218.636,147.236,214.836,146.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M214.836,146.358c0,0-16.855,4.295-21.535,10.699c-2.832,3.876-10.895,21.37-16.822,34.582c2.877-0.583,14.877-2.36,28.927,4.721 c1.358-4.723,2.35-8.446,2.674-9.499c0.985-3.202,8.375-30.297,9.114-31.775C217.933,153.608,218.636,147.236,214.836,146.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M264.241,89.566c0,0,4.68,2.463,6.651,7.143c1.97,4.68,1.97,11.823,1.97,11.823s31.529-0.985,43.598-1.232 c12.07-0.246,20.198,2.71,20.444,8.621c0.246,5.912-2.463,17.489-9.114,21.922c-6.651,4.434-27.341-2.709-37.933-5.665 c-10.592-2.956-14.286-1.971-21.922-2.956c-7.636-0.985-9.853-3.941-11.084-8.621c-1.232-4.68,1.231-13.547,1.231-20.691 C258.083,92.768,257.097,88.088,264.241,89.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M310.302,119.863c0,0-4.434,11.331-12.562,17.488c-5.834,4.42-13.698,6.936-17.672,8.005c-14.203-3.978-34.267-5.879-45.997-3.272 c0,0-16.385,3.918-19.235,4.274c-2.85,0.356-9.617,23.153-11.042,38.826c-1.425,15.673,3.206,54.499,3.206,57.348 c0,2.85,1.781,50.224,4.631,63.404c2.85,13.18,6.055,30.99,6.412,33.483c0.356,2.493,2.85,21.016,2.85,27.071 s-2.85,20.66-2.85,20.66s-12.823,8.549-17.81,13.536c-4.987,4.987,3.669,10.233,9.974,11.398 c10.745,1.985,23.509-8.549,23.509-8.549s14.086-5.634,14.247-5.699c3.793-1.517,4.913-5.59,5.005-9.241 c0.222-8.791,0.445-17.582,0.667-26.373c2.24,9.345,4.079,18.785,5.512,28.287c0.587,3.897,1.18,7.989,3.535,11.149 c1.191,1.597,3.114,3.536,4.944,4.39c1.418,0.662,2.926,0.522,4.351,1.343c2.63,1.516,3.714,4.803,6.268,6.446 c5.017,3.227,12.266,4.894,18.162,4.658c0,0,14.248,0.712,14.96-7.124c0.712-7.836-18.522-20.66-18.522-20.66 s-2.85-52.005-4.987-69.103c-2.137-17.098-7.836-44.881-7.836-56.992c0-12.111,5.699-69.103,5.699-69.103s0.581-1.503,1.472-3.947 c0.312-0.165,0.625-0.336,0.941-0.518c8.129-4.68,30.79-22.908,38.179-34.485c7.075-11.083,9.634-31.875,9.839-37.95"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M311.366,411.371c0.712-7.836-18.522-20.66-18.522-20.66s-0.22-4.006-0.582-10.147c-12.058,2.926-23.627,3.989-34.082,3.977 c0.336,1.987,0.665,3.975,0.965,5.968c0.588,3.897,1.18,7.989,3.535,11.149c1.191,1.597,3.114,3.536,4.944,4.39 c1.419,0.662,2.926,0.522,4.351,1.343c2.63,1.516,3.714,4.803,6.268,6.446c5.017,3.227,12.266,4.894,18.162,4.658 C296.406,418.495,310.654,419.207,311.366,411.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M247.961,397.836c3.793-1.517,4.913-5.59,5.005-9.241c0.035-1.378,0.07-2.757,0.105-4.135 c-14.336-0.489-26.165-2.867-33.694-4.821c-0.681,4.157-1.335,7.51-1.335,7.51s-12.823,8.549-17.81,13.536 c-4.987,4.987,3.669,10.233,9.974,11.398c10.745,1.985,23.509-8.549,23.509-8.549S247.801,397.9,247.961,397.836z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M311.366,411.371c0.011-0.115,0.003-0.234,0.004-0.35c-2.202,1.657-5.577,3.403-10.615,4.299 c-11.258,2.001-21.515-3.753-24.267-6.254c-2.752-2.502-4.503-4.503-8.756-7.255c-4.253-2.752-8.113-9.517-8.113-9.517 l-0.158,0.245c0.531,3.252,1.269,6.505,3.218,9.12c1.191,1.597,3.114,3.536,4.944,4.39c1.419,0.662,2.926,0.522,4.351,1.343 c2.63,1.516,3.714,4.803,6.268,6.446c5.017,3.227,12.266,4.894,18.162,4.658C296.406,418.495,310.654,419.207,311.366,411.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M247.961,397.836c3.306-1.322,4.58-4.587,4.914-7.82c-3.271,1.952-10.86,6.371-15.663,8.293 c-6.254,2.502-10.507,10.007-22.766,10.007c-8.741,0-13.524-3.426-15.557-5.397c-1.084,4.227,5.952,8.175,11.316,9.166 c10.745,1.985,23.509-8.549,23.509-8.549S247.801,397.9,247.961,397.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M294.235,139.667c-5.177,3.007-10.948,4.824-14.167,5.689c-14.203-3.978-34.267-5.879-45.997-3.272c0,0-16.385,3.918-19.235,4.274 c-2.85,0.356-9.617,23.153-11.042,38.826c-0.879,9.673,0.548,28.159,1.769,41.57c29.683,10.879,61.342,7.149,76.824,4.184 c1.566-17.753,3.333-35.424,3.333-35.424s0.581-1.503,1.472-3.947c0.312-0.165,0.625-0.336,0.941-0.518 c5.522-3.18,17.749-12.612,27.341-21.964C296.224,163.499,293.89,148.318,294.235,139.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M266.629,156.663c0-6.075-3.147-11.508-8.1-15.197c-9.098-0.879-18.03-0.811-24.458,0.617c0,0-4.528,1.083-9.237,2.161 c-3.132,3.421-5.016,7.727-5.016,12.418c0,11.11,10.479,20.117,23.405,20.117S266.629,167.773,266.629,156.663z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M259.62,392.293c3.052,1.14,8.737,2.681,16.66,2.336c12.289-0.534,16.563-3.918,16.563-3.918s-2.85-52.005-4.987-69.103 c-2.137-17.098-7.836-44.881-7.836-56.992c0-7.138,1.979-29.864,3.605-47.326c-0.254,0.031-0.509,0.062-0.764,0.091 c-8.695,1.005-16.262-5.932-16.002-14.681l0.338-11.373c0,0-11.22,1.069-27.784-0.801c-16.563-1.87-33.661-7.48-33.661-7.48 l-1.799,0.554c-0.059,0.535-0.113,1.064-0.16,1.584c-1.425,15.673,3.206,54.499,3.206,57.348c0,2.85,1.781,50.224,4.631,63.404 c2.85,13.179,6.055,30.989,6.411,33.483c0.356,2.493,2.85,21.016,2.85,27.071c0,5.946-2.746,20.125-2.845,20.635 c2.138,0.664,6.621,2.019,14.689,4.299c12.289,3.473,20.214-0.712,20.214-0.712c0-4.274,0.712-28.496,0.712-28.496 S258.16,382.71,259.62,392.293z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 218.927,198.052 250.924,203.311 250.924,223.035 232.953,241.006 218.489,223.474  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M242.02,308.945c-2.306-13.024-4.031-25.849-4.031-35.067l-12.823-8.549"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M253.662,362.215c0,0-5.401-20.867-9.862-43.723"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M263.186,251.734c0.276,1.081,0.702,2.189,1.326,3.298c3.945,7.013,9.643,7.89,9.643,7.89l0.877-18.409"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M264.512,241.006c0,0-0.944,1.679-1.447,4.215"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M280.223,297.023c0.462,2.427,0.926,4.815,1.383,7.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M274.154,262.922c0,0,2.251,13.506,4.864,27.67"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M231.984,134.504l-0.181,10.5c0,0-3.621,2.896-4.345,10.5c-0.724,7.603,6.517,14.663,14.664,14.663 c8.146,0,15.207-6.336,16.474-12.129c1.267-5.793-0.362-14.12-0.362-14.12l-0.543-12.672c0,0-7.965,5.069-15.569,3.621 c-7.604-1.448-9.776-4.164-9.776-4.164L231.984,134.504z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M226.312,107.099c0,0-0.487,6.011,0.812,7.473c1.3,1.462,3.087,2.599,3.412,1.3c0.325-1.3,0.487-8.123,0.812-9.585 C231.673,104.824,226.474,103.037,226.312,107.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M229.487,107.01c0,0-1.504,12.031-1.504,17.795c0,5.765-2.256,8.02,5.013,11.78c7.268,3.76,13.535,4.261,18.547,2.507 c5.013-1.755,7.77-6.016,8.02-9.524c0.251-3.509,0.251-9.023,0.251-9.023s7.018-6.266,5.514-11.028 c-1.504-4.762-4.762,1.253-4.762,1.253s2.256-6.266,2.005-12.783c-0.251-6.517-5.263-7.269-7.269-7.269 c-2.005,0-14.286-3.76-20.051,0C229.487,94.478,229.487,107.01,229.487,107.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M260.567,110.77c0,0,2.256-6.266,2.005-12.783c-0.251-6.517-5.263-7.269-7.269-7.269c-0.035,0-0.095-0.009-0.136-0.011 c-1.06,1.784-2.37,4.523-2.37,4.523l1.003,0.501c0,0-1.003,5.514,1.003,6.266c2.005,0.752,1.002,2.506,1.002,5.514 c0,3.008,1.755,5.263,2.757,5.263c0.789,0,2.04-2.012,2.539-2.872C260.771,110.393,260.567,110.77,260.567,110.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M240.771,111.485c0,0-2.112,1.95-1.137,3.412c0.975,1.462,4.549,2.274,5.524,0.487c0.975-1.787-0.163-3.412-0.65-3.737"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M238.496,109.536c0,0.987-0.4,1.787-0.894,1.787c-0.493,0-0.893-0.8-0.893-1.787 s0.4-1.787,0.893-1.787C238.096,107.749,238.496,108.549,238.496,109.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M249.3,110.023c0,0.987-0.4,1.787-0.894,1.787c-0.493,0-0.893-0.8-0.893-1.787 c0-0.987,0.4-1.787,0.893-1.787C248.9,108.236,249.3,109.036,249.3,110.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M246.619,105.149c0,0,3.412-2.274,6.661,1.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      stroke: "#263238",
      strokeWidth: 0.9227,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M241.442,121.142c0,0-1.423-0.766-2.782-0.122c-1.358,0.645-1.617,1.738-1.617,1.738s-2.082,1.676,0.111,2.407 c2.193,0.731,6.971,0.678,8.203,0.621c1.231-0.057,1.636-1.323,1.602-2.07c-0.034-0.747-0.507-0.975-0.507-0.975 S244.774,119.824,241.442,121.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.0733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M236.569,123.386c0,0,4.47-0.94,10.093,0.602"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M225.227,93.225l26.818,3.76c0,0,11.279-3.008,12.281-5.263c1.003-2.256-2.757-13.535-4.762-16.292 c-2.005-2.757-21.304,2.005-27.32,3.008c-6.015,1.003-10.527,2.506-10.276,5.514C222.219,86.959,225.227,93.225,225.227,93.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M225.227,93.225c0,0-15.289,12.532-15.54,13.785c-0.251,1.253,22.307,1.755,29.325,0.251 c7.018-1.504,13.033-10.276,13.033-10.276L225.227,93.225z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M208.522,259.36l42.049-24.629c2.588,1.939,6.19,2.257,9.156,0.52c3.349-1.962,4.801-5.911,3.754-9.474l-8.771,5.137l-2.025-3.458 l8.771-5.137c-2.596-2.656-6.75-3.322-10.1-1.36c-2.966,1.737-4.451,5.034-4.025,8.24l-42.049,24.629 c-2.588-1.939-6.19-2.257-9.156-0.52c-3.349,1.962-4.801,5.911-3.754,9.474l8.54-5.002l2.025,3.458l-8.54,5.002 c2.596,2.656,6.75,3.322,10.1,1.36C207.463,265.862,208.948,262.566,208.522,259.36z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M244.289,241.051c0,0,5.173,3.695,5.173,7.143s-6.158,7.143-10.345,7.39c-4.187,0.246-4.926-4.434-4.187-6.897 C235.668,246.224,244.289,241.051,244.289,241.051z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M190.099,210.261c0,0,28.573,16.011,32.514,15.518c3.941-0.493,9.36-3.941,12.316-2.956 c2.956,0.985,11.084,13.548,11.823,15.764c0.739,2.217-5.912,10.099-7.389,11.331c-1.478,1.232-6.158,6.158-7.143,6.651 c-0.985,0.493-7.389,6.158-10.592,6.158c-3.202,0-8.621-2.463-9.114-3.695c-0.493-1.231,0.739-2.956,0.739-2.956l-15.025-6.897 c0,0-28.573-15.518-33.499-23.4c-4.926-7.882,7.389-21.922,7.389-21.922"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M223.106,248.933c0,0,2.956,0.246,3.448,3.448c0.493,3.202-0.739,8.867-0.739,8.867"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M228.771,244.253c0,0,3.448,0.246,3.448,3.448c0,3.202,0,8.867,0,8.867"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M232.466,235.386c0,0,6.404,4.68,6.897,7.389c0.492,2.71,0,7.143,0,7.143"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M261.025,218.501c1.431,0,5.248-9.541,5.248-13.119c0-3.578,1.67-29.816,5.486-41.981c2.738-8.729,5.102-15.473,6.222-18.597 c-2.912-0.746-6.017-1.409-9.225-1.964c-1.906,5.788-7.738,23.856-10.116,35.35c-2.862,13.835-2.147,30.293-1.908,31.724 C256.97,211.345,259.593,218.501,261.025,218.501z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M265.128,199.208l-8.206-1.089c-0.672-0.089-1.145-0.706-1.055-1.379l0.869-6.551c0.089-0.672,0.707-1.145,1.379-1.056 l8.206,1.089c0.672,0.089,1.145,0.706,1.056,1.378l-0.869,6.551C266.417,198.825,265.8,199.298,265.128,199.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M263.368,197.271l-4.241-0.563c-0.672-0.089-1.145-0.706-1.056-1.378l0.425-3.203c0.089-0.672,0.706-1.145,1.378-1.056 l4.242,0.563c0.672,0.089,1.145,0.706,1.055,1.379l-0.425,3.203C264.657,196.888,264.04,197.361,263.368,197.271z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M207.595,214.923c1.431,0,5.248-9.541,5.248-13.119c0-3.578,1.67-29.816,5.486-41.981c2.424-7.726,4.075-12.653,4.959-15.226 c-3.724,0.844-7.264,1.612-8.452,1.76c-0.875,0.109-2.12,2.34-3.465,5.825c-1.58,4.895-3.515,11.271-5.036,17.477 c-1.17,5.278-2.106,10.733-2.541,15.524c-0.367,4.039-0.329,9.622-0.075,15.722c0.023,0.181,0.043,0.326,0.059,0.421 C204.017,202.758,206.163,214.923,207.595,214.923z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M212.064,191.723l-8.232-0.879c-0.674-0.072-1.162-0.677-1.09-1.351l0.701-6.571c0.072-0.674,0.677-1.162,1.351-1.09 l8.232,0.878c0.674,0.072,1.162,0.677,1.09,1.351l-0.701,6.571C213.343,191.306,212.738,191.795,212.064,191.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.2565,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M210.255,189.831L206,189.377c-0.674-0.072-1.162-0.677-1.09-1.351l0.343-3.213c0.072-0.674,0.677-1.162,1.351-1.09l4.255,0.454 c0.674,0.072,1.162,0.677,1.09,1.351l-0.343,3.213C211.534,189.415,210.929,189.903,210.255,189.831z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalServerError);
export default __webpack_public_path__ + "static/media/InternalServerError.4158c2db5423fa3be9466244263e3a0d.svg";
export { ForwardRef as ReactComponent };